import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22layout.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../assets/fonts/inter/inter-400.ttf%22,%22weight%22:%22400%22,%22style%22:%22normal%22},{%22path%22:%22../assets/fonts/inter/inter-500.ttf%22,%22weight%22:%22500%22,%22style%22:%22normal%22},{%22path%22:%22../assets/fonts/inter/inter-600.ttf%22,%22weight%22:%22600%22,%22style%22:%22normal%22},{%22path%22:%22../assets/fonts/inter/inter-700.ttf%22,%22weight%22:%22700%22,%22style%22:%22normal%22}],%22display%22:%22swap%22}],%22variableName%22:%22inter%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'inter', 'inter Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
